import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';

import Banner from 'images/logo.png';
import Colors from 'utils/Colors';
import Responsive from 'utils/ResponsiveValues';

const SidebarContainer = styled.div`
  width: 400px;
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  overflow-x: hidden;
  height: 100vh;
  
  padding-top: 60px;
  display: flex;
  float: left;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: ${Colors.sidebarBackground};
  color: ${Colors.white};

  @media(max-width: ${Responsive.sidebarMedium}px) {
    width: 300px;
  }

  @media(max-width: ${Responsive.sidebarNone}px) {
    width: 100%;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SidebarButton = styled.button`
  height: 56px;
  width: 50%;
  margin-bottom: 10px;
  border-radius: 5px;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  background-color: ${Colors.sidebarBackground};
  color: ${Colors.white};
  border: 2px solid #fff;
`;

const SidebarButtonActive = styled(SidebarButton)`
  background-color: ${Colors.whiteBackground};
  color: ${Colors.sidebarBackground};
`;

const MobileToggleContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;

  display: none;
  width: 40px;
  height: 40px;

  > div {
    width: 30px;
    height: 3px;
    margin: 6px 0;
    z-index: 12;
  }

  cursor: pointer;
  z-index: 10;

  @media(max-width: ${Responsive.sidebarNone}px) {
    display: block;
  }
`;

const MobileToggle = props => (
  <MobileToggleContainer onClick={props.onClick}>
    <div style={{backgroundColor: props.menuOpen ? '#fff' : '#111'}}/>
    <div style={{backgroundColor: props.menuOpen ? '#fff' : '#111'}}/>
    <div style={{backgroundColor: props.menuOpen ? '#fff' : '#111'}}/>
  </MobileToggleContainer>
);

MobileToggle.propTypes = {
  onClick: PropTypes.func,
  menuOpen: PropTypes.bool,
};

const HeaderImage = styled.img`
  width: 80%;
`;


class SidebarComponent extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      showSidebarMobile: false,
      windowWidth: window.innerWidth,
    };
  }

  resize = () => {
    this.setState({windowWidth: window.innerWidth});
  };

  componentDidMount() {
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  onButtonClick(url) {
    const { navigate } = this.props;

    this.toggleMenu();

    navigate(url);
  }

  toggleMenu = () => {
    this.setState({showSidebarMobile: !this.state.showSidebarMobile});
  };

  render() {
    const { location } = this.props;

    const loggedIn = ['/payments', '/contract', '/settings', '/help'].includes(location.pathname);

    return (
      <React.Fragment>
        <SidebarContainer style={{ display: (this.state.windowWidth > Responsive.sidebarNone || this.state.showSidebarMobile) ? 'block' : 'none'}}>
          <div style={{width: '100%', textAlign: 'center'}}>
            <a href="/"><HeaderImage src={Banner} alt="Banner" /></a>
          </div>
          {loggedIn ?
            <ButtonsContainer>
              {location.pathname === '/contract'
                ?
                <SidebarButtonActive>Abonnement</SidebarButtonActive>
                :
                <SidebarButton onClick={() => this.onButtonClick('/contract')}>Abonnement</SidebarButton>
              }

              {location.pathname === '/payments'
                ?
                <SidebarButtonActive>Betaling</SidebarButtonActive>
                :
                <SidebarButton onClick={() => this.onButtonClick('/payments')}>Betaling</SidebarButton>
              }

              {location.pathname === '/settings'
                ?
                <SidebarButtonActive>Min Profil</SidebarButtonActive>
                :
                <SidebarButton onClick={() => this.onButtonClick('/settings')}>Min Profil</SidebarButton>
              }
              {location.pathname === '/help'
                ?
                <SidebarButtonActive>Hjelp</SidebarButtonActive>
                :
                <SidebarButton onClick={() => this.onButtonClick('/help')}>Hjelp</SidebarButton>
              }
              <SidebarButton onClick={() => this.onButtonClick('/logout')}>Logg ut</SidebarButton>
            </ButtonsContainer>
            :
            <ButtonsContainer>
            </ButtonsContainer>
          }
        </SidebarContainer>
        <MobileToggle menuOpen={this.state.showSidebarMobile} onClick={this.toggleMenu}></MobileToggle>
      </React.Fragment>
    );
  }
}

SidebarComponent.propTypes = {
  navigate: PropTypes.func,
  location: PropTypes.object,
};

// Wrapper component to inject location and navigate hooks
function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  return <SidebarComponent location={location} navigate={navigate} />;
}

export default Header;
